
import React, { useContext, useEffect, useState } from 'react';
import Layout from './Layout';
import { LayoutDashboard, ClipboardList, Link2, Upload, PlayCircle, Share2 } from 'lucide-react';
import EventContext from '../contexts/EventContext';
import { Link } from 'react-router-dom';
import RegistrationDashbord from './RegistrationDashbord';
import { API_URL } from '../config';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import useGetPartenaires from '../customHooks/useGetPartenaires';

const RegistrationDashbordNav = ({ isAdmin, profile }) => {

    const { currentEvent } = useContext(EventContext);
    const { ownerIdContact } = useParams();

    return (

        <div className=" flex flex-wrap items-center gap-x-4 gap-y-3 p-4 bg-white dark:bg-neutral-900 rounded-xl shadow-md mb-6">

            <Link
                to={`${ownerIdContact ? `/events/${currentEvent?.id_event}/registration-dashboard-coordinateur/c/${ownerIdContact}` : `/events/${currentEvent?.id_event}/registration-dashboard/`}`}
                className="flex items-center dark:text-white  text-gray-700 hover:text-blue-600 font-medium transition-colors">
                <LayoutDashboard className="h-5 w-5 mr-2 text-gray-400" />
                <span>Accueil</span>
            </Link>
            {/* 
            {profile !== "coordinateur" && (
                <Link
                    target="_blank"
                    rel="noreferrer"
                    to={`${ownerIdContact ? `/events/${currentEvent?.id_event}/registration-dashboard-forms/c/${ownerIdContact}` : `/events/${currentEvent?.id_event}/registration-dashboard-forms/`}`}
                    className="flex items-center  dark:text-white  text-gray-700 hover:text-blue-600 font-medium transition-colors">
                    <Camera className="h-5 w-5 mr-2 text-gray-400" />
                    <span>Formulaires</span>
                </Link>


            )} */}

            {["coordinateur", "admin"].includes(profile) && (
                <a
                    target="_blank"
                    rel="noreferrer"
                    href={`https://www.event2one.com/screen_manager/content/contact/?&content=fiche_production&target=obs&id_event_ligne=${currentEvent?.event_ligne.id_event_ligne}&id_contact=227438`}
                    className="flex items-center dark:text-white text-gray-700 hover:text-blue-600 font-medium transition-colors">
                    <ClipboardList className="h-5 w-5 mr-2 text-gray-400" />
                    <span>Fiche prod.</span>
                </a>)}



            {
                //["coordinateur", "admin"].includes(profile) && (
                <Link
                    to={`${ownerIdContact ? `/events/${currentEvent?.id_event}/registration-dashboard-links/c/${ownerIdContact}` : `/events/${currentEvent?.id_event}/registration-dashboard-links/`}`}
                    className="flex items-center dark:text-white text-gray-700 hover:text-blue-600 font-medium transition-colors">
                    <Link2 className="h-5 w-5 mr-2 text-gray-400" />
                    <span>Formulaires</span>
                </Link>
                //)
            }

            {/* <Link
                        target="_blank"
                        rel="noreferrer"
                        to={`${ownerIdContact ? `/events/${currentEvent?.id_event}/registration-dashboard-details/c/${ownerIdContact}` : `/events/${currentEvent?.id_event}/registration-dashboard-details/`}`}
                        className="flex items-center text-gray-700 hover:text-blue-600 font-medium transition-colors">
                        <Users className="h-5 w-5 mr-2 text-gray-400" />
                        <span>Inscriptions</span>
                    </Link> */}
            {/* 
            <Link


                to={`${ownerIdContact ? `/events/${currentEvent?.id_event}/partenaires-supports/c/${ownerIdContact}` : `/events/${currentEvent?.id_event}/registration-dashboard-details/`}`}
                className="flex items-center dark:text-white  text-gray-700 hover:text-blue-600 font-medium transition-colors">
                <FileCheck className="h-5 w-5 mr-2 text-gray-400" />
                <span>Gérer les inscriptions</span>
            </Link>

            <Link
                to={`${ownerIdContact ? `/events/${currentEvent?.id_event}/registration-dashboard-details/c/${ownerIdContact}` : `/events/${currentEvent?.id_event}/registration-dashboard-details/`}`}
                className="hidden flex items-center text-gray-700 hover:text-blue-600 font-medium transition-colors">
                <FileCheck className="h-5 w-5 mr-2 text-gray-400" />
                <span>Gérer les inscriptions</span>
            </Link> */}

            {["coordinateur", "admin"].includes(profile) && (
                <>
                    <Link
                        to={`${ownerIdContact ? `/events/${currentEvent?.id_event}/registration-dashboard-captations-admin/c/${ownerIdContact}` : `/events/${currentEvent?.id_event}/registration-dashboard-captations-admin/`}`}
                        className="flex items-center dark:text-white  text-gray-700 hover:text-blue-600 font-medium transition-colors">
                        <Upload className="h-5 w-5 mr-2 text-gray-400" />
                        <span>Chargement </span>
                    </Link>
                    {/* <Link
                        target="_blank"
                        rel="noreferrer"
                        to={`${ownerIdContact ? `/events/${currentEvent?.id_event}/post-generator/c/${ownerIdContact}` : `/events/${currentEvent?.id_event}/post-generator`}`}
                        className="flex items-center dark:text-white  text-gray-700 hover:text-blue-600 font-medium transition-colors">
                        <Camera className="h-5 w-5 mr-2 text-gray-400" />
                        <span>Generateur de post</span>
                    </Link> */}
                    <Link
                        target="_blank"
                        rel="noreferrer"
                        to={`${ownerIdContact ? `/events/${currentEvent?.id_event}/replay/c/${ownerIdContact}` : `/events/${currentEvent?.id_event}/replay/`}`}
                        className="flex items-center dark:text-white  text-gray-700 hover:text-blue-600 font-medium transition-colors">
                        <PlayCircle className="h-5 w-5 mr-2 text-gray-400" />
                        <span>Portail vidéos</span>
                    </Link>

                    <Link
                        to={`${ownerIdContact ? `/events/${currentEvent?.id_event}/viral/c/${ownerIdContact}` : `/events/${currentEvent?.id_event}/viral/`}`}
                        className="flex items-center dark:text-white  text-gray-700 hover:text-blue-600 font-medium transition-colors">
                        <Share2 className="h-5 w-5 mr-2 text-gray-400" />
                        <span>Viralité</span>
                    </Link>

                    <Link
                        to={`${ownerIdContact ? `/events/${currentEvent?.id_event}/registration-dashboard-livraison/c/${ownerIdContact}` : `/events/${currentEvent?.id_event}/registration-dashboard-livraison/`}`}
                        className="flex items-center dark:text-white  text-gray-700 hover:text-blue-600 font-medium transition-colors">
                        <Upload className="h-5 w-5 mr-2 text-gray-400" />
                        <span>Livraison</span>
                    </Link>

                    <Link
                        to={`/check-inscriptions/`}
                        className="flex items-center dark:text-white  text-gray-700 hover:text-blue-600 font-medium transition-colors">
                        <ClipboardList className="h-5 w-5 mr-2 text-gray-400" />
                        <span>Sand box / Check Inscriptions </span>
                    </Link>

                    <Link
                        to={`${ownerIdContact ? `/events/${currentEvent?.id_event}/portfolio/c/${ownerIdContact}` : `/events/${currentEvent?.id_event}/portfolio/`}`}
                        className="flex items-center dark:text-white  text-gray-700 hover:text-blue-600 font-medium transition-colors">
                        <ClipboardList className="h-5 w-5 mr-2 text-gray-400" />
                        <span>Portefolio </span>
                    </Link>

                    <Link
                        to={`${ownerIdContact ? `/events/${currentEvent?.id_event}/partenaires-supports/c/${ownerIdContact}` : `/events/${currentEvent?.id_event}/partenaires-supports/`}`}
                        className="flex items-center dark:text-white  text-gray-700 hover:text-blue-600 font-medium transition-colors">
                        <ClipboardList className="h-5 w-5 mr-2 text-gray-400" />
                        <span>Inscriptions </span>
                    </Link>

                    <Link
                        to={`${ownerIdContact ? `/events/${currentEvent?.id_event}/registration-dashboard-params/c/${ownerIdContact}` : `/events/${currentEvent?.id_event}/registration-dashboard-params/`}`}
                        className="flex items-center dark:text-white  text-gray-700 hover:text-blue-600 font-medium transition-colors">
                        <ClipboardList className="h-5 w-5 mr-2 text-gray-400" />
                        <span>Paramètres </span>
                    </Link>
                </>
            )}
        </div>
    )
}

export default RegistrationDashbordNav